<app-inner-box>
  <app-subpage-header title="Großgebinde"></app-subpage-header>
  <app-articles-list></app-articles-list>
</app-inner-box>
